module.exports = __webpack_public_path__ + "img/vip_provincial.9017729e.png";